/* Cookie consent sheet.

   The buttons call Shopify's Customer Privacy API rather than only hiding the
   sheet, so a decline actually stops the tracking instead of merely looking
   like it did. The API arrives on demand, so it is loaded first and the sheet
   stays hidden until we can honour what the visitor picks. Showing a consent
   choice we could not act on would be worse than showing none.

   Shopify remembers the answer in its own cookie, so the sheet is shown only
   while the visitor has not answered yet. */
(function () {
  var KEYS = ['analytics', 'marketing', 'preferences'];

  function init(api) {
    var box = document.getElementById('cookie-consent');
    if (!box) return;

    var prefs = box.querySelector('[data-consent-prefs]');
    var manage = box.querySelector('[data-consent-manage]');
    var save = box.querySelector('[data-consent-save]');
    var accept = box.querySelector('[data-consent-accept]');
    var decline = box.querySelector('[data-consent-decline]');

    function alreadyAnswered() {
      try {
        var c = api.currentVisitorConsent();
        /* Shopify returns empty strings until something has been chosen. */
        return !!(c && (c.analytics || c.marketing || c.preferences) &&
          String(c.analytics) !== '');
      } catch (e) {
        return false;
      }
    }

    function apply(consent, done) {
      var payload = {
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: !!consent.preferences,
      };
      /* Some regions treat targeted advertising as a sale of data; keeping it
         tied to the marketing answer is the honest reading of the choice. */
      payload.sale_of_data = payload.marketing;
      try {
        api.setTrackingConsent(payload, function () {
          box.hidden = true;
          if (done) done();
        });
      } catch (e) {
        box.hidden = true;
      }
    }

    function readChecks() {
      var out = {};
      KEYS.forEach(function (k) {
        var input = box.querySelector('[data-consent-key="' + k + '"]');
        out[k] = input ? input.checked : false;
      });
      return out;
    }

    accept.addEventListener('click', function () {
      apply({ analytics: true, marketing: true, preferences: true });
    });

    decline.addEventListener('click', function () {
      apply({ analytics: false, marketing: false, preferences: false });
    });

    manage.addEventListener('click', function () {
      var opening = prefs.hidden;
      prefs.hidden = !opening;
      save.hidden = !opening;
      accept.hidden = opening;
      decline.hidden = opening;
      manage.textContent = opening ? 'Back' : 'Manage preferences';
    });

    save.addEventListener('click', function () {
      apply(readChecks());
    });

    if (!alreadyAnswered()) box.hidden = false;
  }

  function boot() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (window.Shopify.customerPrivacy) init(window.Shopify.customerPrivacy);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
